import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';


import SlideHome  from './slide-home/slide-home';
import SlideSecondHome  from './slide-second-home/slide-second-home';
import SlideClient  from './slide-client/slide-client';
import CategoryHome  from './category-home/category-home';

class Home extends Component {
    constructor(props) {
        super(props);
        localStorage.setItem('catData',"");
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        return (
            <div>
                <MetaTags defer={false}>
                    <title>Market Research - Consulting, Reports, Advisory, Sizing | Consulting -
                        Client Research, Market Analysis | Competitive Landscape Analysis | Global Strategic
                        Business Reports | Custom Market Research - Mordor Intelligence</title>
                    <meta id="description" name="description" content="Custom Market Research - Mordor Intelligence" />
                    <meta id="title" property="og:title" content="Mordor Intelligence" />
                    <meta id="image" property="og:image" content="https://mordorintelligence.com:81/images/mordor_logo.png" />
                </MetaTags>
                <SlideHome />
                <SlideSecondHome />
                <SlideClient />
                <CategoryHome />
            </div>
        );
    }


}


export default Home;


// WEBPACK FOOTER //
// ./src/home/Home.js